import { useEffect, useState } from "react";
import { transparentLogoPreview } from "@/lib/logo-background";

export function PdfLogoPreview({ url, removeBackground }: { url: string; removeBackground: boolean }) {
  const [result, setResult] = useState<{ key: string; data?: string; error?: string } | null>(null);
  useEffect(() => {
    if (!removeBackground) return;
    let active = true;
    transparentLogoPreview(url).then(
      data => { if (active) setResult({ key: url, data }); },
      error => { if (active) setResult({ key: url, error: error instanceof Error ? error.message : "Logo processing failed." }); },
    );
    return () => { active = false; };
  }, [url, removeBackground]);
  if (removeBackground && result?.key !== url) return <span className="text-[10px] text-muted-foreground">Processing…</span>;
  if (removeBackground && result?.error) return <span role="alert" className="text-[10px] text-destructive">{result.error}</span>;
  return <img src={removeBackground ? result?.data : url} alt="Document logo" className="max-h-12 max-w-[88px] object-contain" data-testid="img-template-logo" />;
}
